<svelte:head>
  <title>Charity | A Good Thing</title>
</svelte:head>
<!-- svelte-ignore a11y-label-has-associated-control -->
<!-- svelte-ignore a11y-missing-attribute -->

{#if showToast}
  <div class="notification is-success">
    <button class="delete" on:click={() => showToast = false}></button>
    Details saved.
  </div>
{/if}

{#if !isOwnershipVerified}
  <div class="block">
    <div class="notification is-danger is-light">
      You cannot edit your postcode or charity email until we have verified your account
    </div>
  </div>
{/if}

<div class="field is-horizontal">
  <div class="field-label is-normal">
    <label for="name" class="label">Charity name</label>
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        <input
          id="name"
          disabled
          class="input"
          type="text"
          placeholder=""
          bind:value={data.name} />
      </div>
    </div>
  </div>
</div>

<div class="field is-horizontal">
  <div class="field-label is-normal">
    <label for="description" class="label">Description</label>
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        <textarea
          id="description"
          class="textarea"
          placeholder=""
          rows="10"
          bind:value={data.description}
        />
      </div>
    </div>
  </div>
</div>

<div class="field is-horizontal">
  <div class="field-label is-normal">
    <label for="website" class="label">Website</label>
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        <input id="website" class="input" type="text" placeholder="" bind:value={data.website}/>
      </div>
    </div>
  </div>
</div>

<div class="field is-horizontal">
  <div class="field-label is-normal">
    <label for="addressline1" class="label">Address</label>
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        <input id="addressline1" class="input" type="text" placeholder="Address line 1" bind:value={data.contact.address[0]} />
      </div>
    </div>
  </div>
</div>

<div class="field is-horizontal">
  <div class="field-label is-normal">
    <label for="addressline2" class="label" />
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        <input id="addressline2" class="input" type="text" placeholder="Address line 2" bind:value={data.contact.address[1]} />
      </div>
    </div>
  </div>
</div>

<div class="field is-horizontal">
  <div class="field-label is-normal">
    <label for="addressline3" class="label" />
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        <input id="addressline3" class="input" type="text" placeholder="Address line 3" bind:value={data.contact.address[2]} />
      </div>
    </div>
  </div>
</div>

<div class="field is-horizontal">
  <div class="field-label is-normal">
    <label for="addressline4" class="label" />
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        <input id="addressline4" class="input" type="text" placeholder="Address line 4" bind:value={data.contact.address[3]} />
      </div>
    </div>
  </div>
</div>

<div class="field is-horizontal">
  <div class="field-label is-normal">
    <label for="postcode" class="label" />
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        <input
          id="postcode"
          class="input"
          type="text"
          placeholder="Postcode"
          disabled={!isOwnershipVerified}
          bind:value={data.contact.postcode} />
      </div>
    </div>
  </div>
</div>

<div class="field is-horizontal">
  <div class="field-label is-normal">
    <label for="email" class="label">Charity email</label>
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        <input
          id="email"
          class="input"
          type="email"
          name="email"
          placeholder=""
          disabled={!isOwnershipVerified}
          bind:value={data.contact.email}/>
      </div>
    </div>
  </div>
</div>

<div class="field is-horizontal">
  <div class="field-label">
    <!-- Left empty for spacing -->
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        <button class="button is-primary" class:is-loading={isLoading} on:click={save}>Save</button>
      </div>
    </div>
  </div>
</div>

{#if errorMessage}
  <div class="block">
    <div class="notification is-danger is-light">
      {errorMessage}
    </div>
  </div>
{/if}

<script lang="ts">

  import _ from "lodash";
  import { logging } from '../../../lib/logging';
  import { appState } from "../../../lib/appState";

  // pick out data to edit
  let data = {
    name: $appState.charity!.name,
    description: $appState.charity!.description,
    website: $appState.charity!.website,
    contact: $appState.charity!.contact
  };

  const isOwnershipVerified = $appState.charity?.isOwnershipVerified;

  let showToast = false;
  let errorMessage : string;
  let isLoading = false;

  const firebase = window.firebase;

  if(!data.contact) {
    data.contact = {
      email: '',
      address: [],
      phone: '',
      social: [],
      postcode: ''
    };
  }

  if (!data.contact.address) {
    data.contact.address = [];
  }

  while(data.contact.address.length < 4) {
    data.contact.address.push('');
  }

  async function save() {

    isLoading = true;

    // merge back updates
    const updatedCharity = _.clone($appState.charity);
    _.assign(updatedCharity, data);

    try {
      let result = await firebase.functions().httpsCallable('api-account-updatecharity')({
        id: $appState.user!.charity,
        charity: updatedCharity,
      } as UpdateCharityParams);

      $appState.charity = result.data.charity;

      showToast = true;
    } catch (err: any) {
      logging.report(err.toString());
      errorMessage = err.toString();
    }
    isLoading = false;
  }
</script>
